"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFullStoryUserVars = void 0;
var _1 = require(".");
// Note that custom vars need to be type-suffixed (e.g. _str for strings).
// See "Custom fields" section of this doc for more info: https://help.fullstory.com/develop-js/setuservars
exports.setFullStoryUserVars = function (userVars) {
    if (!_1.isFullStoryInstalled()) {
        return; // bail silently, we don't want to throw an error here
    }
    _1.getFullStory().setUserVars(userVars);
};
